export default __webpack_public_path__ + "static/estimator-luggage_bags-b2604ef5c7bf3f4e7904eedfa8b02b25.svg";